import Header from '../components/Header';
import Footer from '../components/Footer';

function PolicyLayout({ title, children }) {
  return (
    <div className="policy-page">
      <Header />
      <main className="policy-main section section--soft">
        <div className="container policy-content-wrap">
          <h1 className="policy-title">{title}</h1>
          <div className="policy-content">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PolicyLayout;
